import { Autocomplete, TextField } from '@mui/material';
import React from 'react'
import { useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

// delay - швидкість затримки пошуку
const MySelectSearch = ({ 
    options, label, placeholder, id, value, onChange, setQuery, disabled, loading, setLoading, delay = 300, ...rest
}) => {

    const [valueTemp, setValueTemp] = useState('')

    // Знаходимо об’єкт по id
    const [selectedOption, setSelectedOption] = useState(null);

    // Debounce-функція
    const timeoutQuery = useMemo(() => {
        let timeout;
        return (query) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setQuery?.(query);
            }, delay);
        };
    }, [setQuery, delay]);

    // const filterOptions = (options, state) => { // Делаю поиск по сокращенному полю
    //     let newOptions = [];
    //     options.forEach((element) => {
    //         if (
    //             element.name
    //                 // .replace(",", "")
    //                 .toLowerCase()
    //                 .includes(state.inputValue.toLowerCase())
    //         )
    //             newOptions.push(element);
    //     });
    //     return newOptions;
    // }

  return (
    <Autocomplete
        // freeSolo
        disableClearable
        forcePopupIcon={false}
        value={selectedOption}
        onChange={(event, newValue) => {            
            if (newValue) {
                setValueTemp(newValue.name);
                onChange?.(newValue.id);
                setSelectedOption(newValue)
            } else {
                setValueTemp('');
                onChange?.(null);
                setSelectedOption(null)
            }
        }}
        inputValue={valueTemp}
        onInputChange={(event, newInputValue, reason) => {
            setValueTemp(newInputValue);

            // передаємо в батьківський компонент для запиту в БД
            // Викликаємо debounce тільки якщо користувач друкує
            if (reason === 'input') {
                timeoutQuery(newInputValue);
            }

            if (reason === 'clear') {
                onChange?.(null);
            }

            if (newInputValue.length === 0) {
                onChange(null);
                setValueTemp('');
                setSelectedOption(null)
            }
        }}
        id={id}
        size="small"
        options={options}
        disabled={disabled}
        getOptionLabel={(option) =>
            typeof option === 'string'
                ? option
                : option?.name ?? ''
        }
        filterOptions={(x) => x} // Це важливо, що обціʼ цілком брались з БД, а не шукало в наявному
        isOptionEqualToValue={(option, value) => option.id === value.id}
        noOptionsText={ loading ? 'Пошук ...' : 'Не знайдено' }
        // componentsProps={{
        //     paper: {
        //         sx: {
        //         // width: 500
        //         minWidth: 200,
        //         maxWidth: 500
        //         }
        //     }
        // }}
        renderInput={(params) => 
            <TextField
                {...params} 
                // value={valueTemp}
                label={label}
                placeholder={placeholder}
                InputLabelProps={{
                    // ...params.InputLabelProps,
                    shrink: true
                }}
            />
        }
    />
  )
}

export default MySelectSearch